<script setup></script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide w-5 h-5" aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M3 10h5"></path>
        <path d="M3 14h5"></path>
        <path d="M16 10h5"></path>
        <path d="M16 14h5"></path>
        <circle cx="12" cy="12" r="4"></circle>
    </svg>
</template>
